import React from 'react';
import Flagship from '../../core/flagship';
import {Link} from 'react-router';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/appActions';
import {Table, Loader, Label, Dropdown, Input, Icon, Menu, Button} from 'semantic-ui-react';
import {throttle, empty, getFormattedValue} from '../../utils/helpers';

class LineItems extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.jumpToPage = this.jumpToPage.bind(this);
        this.filterStatus = this.filterStatus.bind(this);
        this.filterMarket = this.filterMarket.bind(this);
        this.filterSearch = this.filterSearch.bind(this);
        this.search = this.search.bind(this);
        this.timer = null;

        this.lineItemStatuses =
            {
                "needs-pricing": {
                    "label": "Needs Pricing",
                    "color": "green"
                },
                "priced": {
                    "label": "Priced",
                    "color": "blue"
                }
            };
    }

    getInitialState() {

        let filterStatus = this.props.location.query.status;
        let orderBy = this.props.location.query.orderby;

        let currentFilters = {};
        if ( !empty( filterStatus ) ) {
            currentFilters.status = filterStatus;
        }
        if ( !empty( orderBy ) ) {
            currentFilters.orderby = orderBy;
        }

        return {
            currentFilters,
            currentPage: 1,
            products: [],
            totalCount: 0,
            totalPages: 1,
            loading: true
        }
    }

    componentWillMount() {
        // Call API
        this.getLineItems();
        setTimeout(Flagship.closeSidebarNav,500);
    }

    componentDidMount() {
        document.title =  'Flagship / Line Items';
    }

    componentWillReceiveProps(nextProps) {

        if ( nextProps.route.type !== this.props.route.type ) {
            document.title =  'Flagship / Line Items';
            this.setState(this.getInitialState(), this.getLineItems);
        }
    }

    getLineItems() {

        let self = this;
        Flagship.get(
            'line-items/list/' + this.state.currentPage,
            this.state.currentFilters,
            function(response) {

                if (response.data.success === true) {

                    self.setState({
                        products: response.data.results,
                        totalCount: response.data.totalCount,
                        totalPages: Math.ceil(response.data.totalCount / 15),
                        loading: false
                    });

                } else {
                    Flagship.error("Error getting products from Flagship API server.");
                }
            }
            ,function (err) {
                Flagship.error("Error getting products from Flagship API server: " + err);
            }
        );
    }

    clearFilters() {
        this.setState(
            {
                currentFilters: []
            },
            this.getLineItems
        );
    }

    prevPage() {
        this.setState(
            {
                currentFilters: [],
                currentPage: this.state.currentPage > 1 ? this.state.currentPage - 1: this.state.currentPage
            },
            this.getLineItems
        );
    }

    nextPage() {
        this.setState(
            {
                currentFilters: [],
                currentPage: this.state.currentPage < this.state.totalPages ? this.state.currentPage + 1: this.state.currentPage
            },
            this.getLineItems
        );
    }

    jumpToPage(page) {
        this.setState(
            {
                currentPage: page,
                loading: true
            },
            this.getLineItems
        );
    }

    filterStatus(e, {value}) {

        let currentFilters = Object.assign({}, this.state.currentFilters);

        if (value === 'any') {
            delete currentFilters['status'];

        } else {
            currentFilters['status'] = value;
        }

        this.setState({currentFilters: currentFilters}, this.getLineItems);
    }

    filterMarket(e, {value}) {
        let currentFilters = Object.assign({}, this.state.currentFilters);

        if (value === 'any') {
            delete currentFilters['market'];

        } else {
            currentFilters['market'] = value;
        }

        this.setState({currentFilters: currentFilters}, this.getLineItems);
    }

    filterSearch(value) {
        this.setState({currentFilters: {"search": value}}, this.getLineItems);
    }

    search(e) {
        e.persist();
        let filterSearch = this.filterSearch;
        this.timer = throttle( function() {
            filterSearch(e.target.value);
        }, 500, this.timer);
    }

    render() {

        const displayBody = () => {
            if ( this.state.loading ) {
                return (
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell colSpan="6">
                                <Loader className="flagship-loader" active inline='centered' />
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                );
            } else if (!this.state.products.length) {
                return (
                    <Table.Body>
                        <Table.Row className="no-results">
                            <Table.Cell colSpan="6">
                                <Icon name="thumbs down" size="huge" />
                                <h3>Nothing Found.</h3>
                                <p>Flagship did not find any products that match the criteria you've selected.</p>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                );
            } else {

                return (
                    <Table.Body>
                        {(
                        typeof this.state.products === "object" &&
                        this.state.products !== null) ?
                        this.state.products.map(function (row, i) {

                            let lineItemLink = '/rfp/view/' + row.record_key + '/focus/' + row.line_item_key;

                            let service = '';

                            Flagship.config.lineItemServices.map(function(element) {
                                if ( element.hasOwnProperty("subOptions")) {
                                    let innerFound = element.subOptions.find(function(subElement) {
                                        return subElement.value === row.line_item_type;
                                    });
                                    if (typeof innerFound !== "undefined") {
                                        service = element.text + ' - ' + innerFound.text;
                                    }
                                }
                               if (element.value === row.line_item_type) {
                                   service = element.text;
                               }
                            });



                            return (
                                <Table.Row key={i}>
                                    <Table.Cell key="name">
                                        <Link to={lineItemLink}>
                                            {!empty(service) && row.line_item_name !== service ?
                                                <span>
                                                    {row.line_item_name}
                                                    <em className="table-service-name">({service})</em>
                                                </span>
                                                :
                                                row.line_item_name
                                            }
                                        </Link>
                                    </Table.Cell>
                                    <Table.Cell key="market">
                                        <Link to={lineItemLink}><Label
                                            horizontal>{row.market}</Label></Link>
                                    </Table.Cell>
                                    <Table.Cell key="io">
                                        <Link to={"/rfp/view/" + row.record_key}>{row.record_name} <em className="table-secondary">(#{row.record_key})</em></Link>
                                    </Table.Cell>
                                    <Table.Cell key="strategist">
                                        <Link to={lineItemLink}>
                                            {
                                                empty( row.proposal_strategist ) ?
                                                    "-"
                                                    :
                                                    row.proposal_strategist
                                            }
                                        </Link>
                                    </Table.Cell>
                                    <Table.Cell key="price">
                                        <Link to={lineItemLink}>
                                        { row.price === null ?
                                            <Label color="green">Needs Pricing</Label>
                                            :
                                            <Label color="blue">{getFormattedValue(row.price,"money")}</Label>
                                        }
                                        </Link>
                                    </Table.Cell>
                                </Table.Row>
                            );
                        }): null}
                    </Table.Body>
                );
            }
        };

        let lineItemStatuses = this.lineItemStatuses;

        let currentFilters = this.state.currentFilters;

        let {filterStatus, filterMarket, search} = this;

        const getDropdownTextStatus = () => {

            if (currentFilters && currentFilters.status) {
                return "Status: " + lineItemStatuses[currentFilters.status].label;
            }
            return "Filter by Status";
        };

        const getDropdownTextMarket = () => {
          if (currentFilters && currentFilters.market) {
              return "Market: " + [currentFilters.market];
          }
          return "Filter by Market";
        };

        let dropdownTextStatus = getDropdownTextStatus();
        let dropdownTextMarket = getDropdownTextMarket();


        return (
          <div className="fade-in">
              <div id="view-header-section">
                <h1 className="view-title">RFP Line Items</h1>

                <div className="view-filters">

                    <Dropdown text={dropdownTextStatus}
                              icon='filter'
                              floating
                              labeled
                              button
                              className={
                                  "icon " +
                                  (currentFilters && currentFilters.status ?
                                          "color-" + lineItemStatuses[currentFilters.status].color
                                          : null
                                  )
                              }>
                        <Dropdown.Menu>
                            <Dropdown.Header icon='configure' content='Select a Status' />
                            <Dropdown.Divider />
                            <Dropdown.Item onClick={filterStatus} key="any" value="any">
                                { !this.state.currentFilters || !this.state.currentFilters.status ?
                                    <Icon name="check" />
                                    :
                                    <Icon />
                                }
                                <Label horizontal color="grey">Any Status</Label>
                            </Dropdown.Item>

                            {
                                Object.keys(lineItemStatuses).map(function(key) {
                                    return (
                                        <Dropdown.Item onClick={filterStatus} key={key} value={key} >
                                            { currentFilters && currentFilters.status === key ?
                                                <Icon name="check" />
                                                :
                                                <Icon />
                                            }
                                            <Label horizontal color={lineItemStatuses[key].color}>
                                                {lineItemStatuses[key].label}
                                            </Label>
                                        </Dropdown.Item>
                                    );
                                })
                            }
                        </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown
                      text={dropdownTextMarket}
                      icon='filter'
                      floating
                      labeled
                      button
                      className={
                          "icon " +
                          (currentFilters && currentFilters.market ?
                                  "color-white"
                                  : null
                          )
                      }>
                    <Dropdown.Menu>
                      <Dropdown.Header icon='building' content='Select a Market' />
                      <Dropdown.Divider />
                        <Dropdown.Item onClick={filterMarket} key="any" value="any">
                            { !this.state.currentFilters || !this.state.currentFilters.market ?
                                <Icon name="check" />
                                :
                                <Icon />
                            }
                            <Label horizontal color="grey">Any Market</Label>
                        </Dropdown.Item>
                      {Flagship.config.markets.map( function( market, i ) {
                        return(
                          <Dropdown.Item onClick={filterMarket} value={market} key={i}>
                              { currentFilters && currentFilters.market === market ?
                                  <Icon name="check" />
                                  :
                                  <Icon />
                              }
                              <Label horizontal>{market}</Label>
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown.Menu>
                    </Dropdown>

                    <Button as={Link} to="/rfps" className="view-switch">
                        <Icon name="eye"/>
                        Complete RFPs...
                    </Button>
                </div>

                <div className="view-search">
                  <Input placeholder={"Search " + this.props.route.niceName + '...'} onKeyUp={search} />
                </div>
              </div>

            <Table striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Name</Table.HeaderCell>
                  <Table.HeaderCell>Market</Table.HeaderCell>
                  <Table.HeaderCell>RFP</Table.HeaderCell>
                  <Table.HeaderCell>Proposal Strategist</Table.HeaderCell>
                  <Table.HeaderCell>Price</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              {displayBody()}
                <Table.Footer>
                    <Table.Row>
                        <Table.HeaderCell colSpan="6" className="view-pagination">
                            <Menu pagination>

                                { this.state.currentPage > 1 ?
                                    <Menu.Item icon onClick={this.prevPage}>
                                        <Icon name="chevron left" />
                                    </Menu.Item>
                                    :
                                    <Menu.Item icon disabled>
                                        <Icon name="chevron left" />
                                    </Menu.Item>
                                }

                                { this.state.currentPage > 3 ?
                                    <Menu.Item name ="1" onClick={() => this.jumpToPage(1)}/>
                                    :
                                    null
                                }

                                { this.state.currentPage > 4 ?
                                    <Menu.Item disabled>...</Menu.Item>
                                    :
                                    null
                                }

                                { this.state.currentPage > 2 ?
                                    <Menu.Item name={String(this.state.currentPage - 2)} onClick={() => this.jumpToPage(this.state.currentPage - 2)}/>
                                    :
                                    null
                                }

                                { this.state.currentPage > 1 ?
                                    <Menu.Item name={String(this.state.currentPage - 1)} onClick={() => this.jumpToPage(this.state.currentPage - 1)}/>
                                    :
                                    null
                                }

                                <Menu.Item name={String(this.state.currentPage)} active={true} onClick={() => this.jumpToPage(this.state.currentPage)} />

                                { this.state.currentPage < this.state.totalPages - 1 ?
                                    <Menu.Item name={String(this.state.currentPage + 1)} onClick={() => this.jumpToPage(this.state.currentPage + 1)}/>
                                    :
                                    null
                                }

                                { this.state.currentPage < this.state.totalPages - 2 ?
                                    <Menu.Item name={String(this.state.currentPage + 2)} onClick={() => this.jumpToPage(this.state.currentPage + 2)}/>
                                    :
                                    null
                                }

                                { this.state.currentPage <= 2 && this.state.currentPage < this.state.totalPages -  3 ?
                                    <Menu.Item name={String(this.state.currentPage + 3)} onClick={() => this.jumpToPage(this.state.currentPage + 3)}/>
                                    :
                                    null
                                }

                                { this.state.currentPage <= 1 && this.state.currentPage < this.state.totalPages -  4 ?
                                    <Menu.Item name={String(this.state.currentPage + 4)} onClick={() => this.jumpToPage(this.state.currentPage + 4)}/>
                                    :
                                    null
                                }

                                { this.state.currentPage < this.state.totalPages - 4 ?
                                    <Menu.Item disabled>...</Menu.Item>
                                    :
                                    null
                                }


                                { this.state.currentPage < this.state.totalPages - 3 ?
                                    <Menu.Item name={String(this.state.totalPages)} onClick={() => this.jumpToPage(this.state.totalPages)}/>
                                    :
                                    null
                                }

                                { this.state.currentPage !== this.state.totalPages?
                                    <Menu.Item icon onClick={this.nextPage}>
                                        <Icon name="chevron right" />
                                    </Menu.Item>
                                    :
                                    <Menu.Item icon disabled>
                                        <Icon name="chevron right" />
                                    </Menu.Item>
                                }

                            </Menu>
                            <div className="total-records">
                                Found {this.state.totalCount}
                                {empty(this.state.currentFilters) ?
                                    " total " + this.props.route.niceName + "."
                                    :
                                    " " + this.props.route.niceName + " matching your search criteria."
                                }
                            </div>
                        </Table.HeaderCell>

                    </Table.Row>

                </Table.Footer>
            </Table>

          </div>
        );
    }
}

LineItems.propTypes = {
    actions: PropTypes.object,
    token: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    token: state.main.token,
  };
}

function mapDispatchToProps(dispatch) {

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LineItems);





// WEBPACK FOOTER //
// ./src/components/views/LineItems.js